// CB:BEGIN admin-user-edit-page
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import AdminUserEditForm from '../../components/admin/AdminUserEditForm';
import { useAuth } from '@clerk/clerk-react';

export default function AdminUserEditPage() {
  const { id } = useParams();
  const { getToken } = useAuth();
  const [user, setUser] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string|undefined>();

  useEffect(() => {
    const fetchUser = async () => {
      if (!id) return;
      
      try {
        setLoading(true);
        const token = await getToken();
        const res = await fetch(`/api/admin/users/${id}`, {
          headers: { 
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}) 
          }
        });
        
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        }
        
        const data = await res.json();
        setUser(data.user || data);
      } catch (e: any) {
        console.error('Error fetching user:', e);
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [id, getToken]);

  const handleUserSaved = (updatedUser: any) => {
    setUser(updatedUser);
    // Show success message or redirect
    alert('User updated successfully!');
  };

  if (loading) {
    return (
      <AdminLayout title="Edit User">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span className="ml-2 text-gray-600">Loading user data...</span>
        </div>
      </AdminLayout>
    );
  }

  if (error) {
    return (
      <AdminLayout title="Edit User">
        <div className="bg-red-50 border border-red-200 rounded-md p-4 max-w-2xl mx-auto">
          <h3 className="text-lg font-semibold text-red-800 mb-2">Error Loading User</h3>
          <p className="text-red-600 text-sm mb-4">{error}</p>
          <button 
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
          >
            Retry
          </button>
        </div>
      </AdminLayout>
    );
  }

  if (!user) {
    return (
      <AdminLayout title="Edit User">
        <div className="text-center py-12">
          <p className="text-gray-500">User not found</p>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title={`Edit User: ${user.email}`}>
      <AdminUserEditForm user={user} onSaved={handleUserSaved} />
    </AdminLayout>
  );
}
// CB:END admin-user-edit-page
